import {
    myBusinessUpdatedSuccess,
    myBusinessUpdatedFail,
    myBusinessDataSuccess,
    myBusinessDataFailed
}
    from '../../constant';
import { toast } from "react-toastify";

export const initialState = {
    data : null
};


let toastConfig = {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 2500,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case myBusinessDataSuccess:
            return {
                ...state,
                data: action.payload,
            };
        case myBusinessDataFailed:
            return {
                ...state,
                dataFailed: action.payload.message,
            };
        case myBusinessUpdatedSuccess:
            toast.success("Updated Successfully", toastConfig);
            return {
                ...state,
                updatedData: action.payload,
                data: action.payload
            };
        case myBusinessUpdatedFail:
            toast.error(action.payload.message, toastConfig);
            return {
                ...state,
                myProfileUpdatedFail: action.payload.message,
            };
        default:
            return state;
    }
}